import { appToken, urls } from "../constants/urlConstants";
import AuthService from "./AuthService";

class APIService {

    apiCall(methodType, content, type) {
        let reqURL = urls[type.trim()];
        let token = appToken
        if (AuthService != null && AuthService.getToken() != null && AuthService.getToken().length > 1)
            token = AuthService.getToken()
        let reqHeaders = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        }
        if (methodType === "POST")
            return fetch(reqURL, {
                headers: reqHeaders,
                method: methodType,
                body: JSON.stringify(content),
                mode: 'cors'
            });
        else if (methodType === "GET") {
            return fetch(reqURL, {
                headers: reqHeaders,
                method: methodType,
                mode: "cors",
            });
        }
        else if (methodType === "POSTFORMDATA") {
            return fetch(reqURL, {
                headers: {
                    Authorization: "Bearer " + token,
                },
                method: "POST",
                body: content,
                mode: "cors",
            });
        }
    }



}

export default new APIService();
